<br>
<ng-container>
    <p class="textSubHeader">
        Mi agenda
    </p>

    <p class="textHeader">
        Atiéndete con nosotros
    </p>
</ng-container>


<div class="row mb-2 mb-sm-4 mt-1 mt-sm-4">
    <div class="col-12">
        <h3 class="mb-3 mt-0">Selecciona una modalidad de atención</h3>
        <div class="card-deck flex-column flex-md-row">
            <div class="card mb-3" style="border-color: #316AD8;">
                <div class="image-container">
                    <img class="card-img-top" src="assets/images/home/utilizar-1.jpg" alt="utilizar alamedis 1">
                </div>
                <div class="card-block px-3 px-sm-3 pt-2 pt-sm-3 pb-3">
                    <p class="card-text" style="color: #0e0087">Agenda con tu profesional de confianza </p>
                    <p class="card-subtext"> Reserva una consulta a tu conveniencia con uno de nuestros profesionales de
                        la salud.</p>
                    <div class="buttons-box row">
                        <div class="col">

                            <button type="button" (click)="redirectToMesaAyuda()" class="btn btn-primary"
                                style="background: #316AD8;">
                                Preguntas frecuentes
                            </button>
                        </div>
                        <div class="col">
                            <button type="button" (click)="reservaHora()" class="btn btn-primary">
                                Reserva tu hora
                            </button>

                        </div>
                    </div>
                </div>
            </div>

            <div class="card mb-3"
                style="border-color: #2babb7;">
                <div class="image-container">
                    <img class="card-img-top" src="assets/images/home/utilizar-3.jpg" alt="utilizar alamedis 1">


                    <ng-container *ngIf="!tiempoEspera.onWaitlist && tiempoEspera.filaDisponible">

                        <!-- Primera viñeta -->
                        <div class="step-overlay row">
                            <div class="col col-2 d-flex">
                                <mat-icon>schedule</mat-icon>
                            </div>
                            <div class="col col-2">
                                <p class="m-0"><b>{{ redondearTiempo(tiempoEspera.data.tiempoEspera) }}</b></p>
                            </div>
                            <div class="col col-8  d-flex">
                                <span><b>Minutos</b> de espera</span>
                            </div>
                        </div>

                        <!-- Segunda viñeta -->
                        <div class="step-overlay-second row">
                            <div class="col col-2  d-flex">
                                <mat-icon>person_outline</mat-icon>
                            </div>
                            <div class="col col-2">
                                <p class="m-0" style="font-size: 16px;"><b>{{ tiempoEspera.data.totalPacientes }}</b>
                                </p>
                            </div>
                            <div class="col col-8 d-flex">
                                <span><b>Personas</b> en la fila</span>
                            </div>
                        </div>
                    </ng-container>

                    <ng-container *ngIf="!tiempoEspera.filaDisponible && !tiempoEspera.onWaitlist">
                        <div class="overlay-no-disponible row" style="  justify-content: flex-end;">
                            <div class="col-9 mensaje-overlay">
                                {{tiempoEspera.msg}}
                            </div>
                        </div>
                    </ng-container>
                    <ng-container *ngIf="tiempoEspera.onWaitlist && tiempoEspera.consulta.sta_id != 116">
                        <div class="overlay-no-disponible row" style="  justify-content: flex-end;">
                            <div class="col-11 mensaje-overlay" style=" background: #2babb7; color: white;">
                                <b style="font-weight: 700;">Ya estás en la fila.</b> Te avisaremos cuando sea tu turno.
                            </div>
                        </div>
                    </ng-container>
                    <ng-container *ngIf="tiempoEspera.onWaitlist && tiempoEspera.consulta.sta_id == 116">
                        <div class="overlay-no-disponible row" style="  justify-content: flex-end;">
                            <div class="col-11 mensaje-overlay" style=" background: #2babb7; color: white;">
                                <b style="font-weight: 700;">¡Ya es tu turno!</b> Conéctate a la consulta para comenzar
                                tu atención.
                            </div>
                        </div>
                    </ng-container>

                </div>


                <div class="card-block px-3 px-sm-3 pt-2 pt-sm-3 pb-3">
                    <p class="card-text" style="color: #2F7586">Atención inmediata</p>
                    <p class="card-subtext">Obtén atención médica al instante con nuestra modalidad de atención
                        inmediata.</p>
                    <div class="row cardInfo">
                        <div class="col-1 d-flex">
                            <mat-icon style="color: #171994;">info</mat-icon>

                        </div>

                        <div class="col-11" style="font-family: 'Mulish';">

                            Este servicio no reemplaza a una atención de urgencia médica.
                        </div>
                        <div class="col-12">
                        </div>
                    </div>
                    <div class="buttons-box row">
                        <div class="col">
                            <button type="button" (click)="redirectToMesaAyuda()" class="btn btn-primary"
                                style="background: #2babb7;">
                                Preguntas frecuentes
                            </button>

                        </div>
                        <div class="col" *ngIf="!tiempoEspera.onWaitlist">
                            <button type="button" (click)="reservaOnDemand()" class="btn btn-primary"
                                [disabled]="!tiempoEspera?.filaDisponible" [ngStyle]="{
                                    'background': (!tiempoEspera?.filaDisponible) ? '#B0B0B0' : '#2F7586',
                                    'border-color': (!tiempoEspera?.filaDisponible) ? '#B0B0B0' : '#2F7586'
                                    }">
                                Atiéndete ahora
                            </button>

                        </div>
                        <div class="col" *ngIf="tiempoEspera.onWaitlist && tiempoEspera.consulta.sta_id != 116">
                            <button type="button" (click)="redirectToFilaEspera()" class="btn btn-primary"
                                style="background-color: #2F7586;">
                                Ir a la fila de espera
                            </button>

                        </div>
                        <div class="col" *ngIf="tiempoEspera.onWaitlist && tiempoEspera.consulta.sta_id == 116">
                            <button type="button" (click)="redirectToSalaEspera()" class="btn btn-primary"
                                style="background-color: #2F7586;">
                                Ir a la sala de espera
                            </button>

                        </div>

                    </div>
                </div>
            </div>
           
        </div>
    </div>
</div>